import { Menu } from 'antd'
import React, { FC } from 'react'
import { Link } from '../../BusinessLogic'
import { adminSubNav } from '../../BusinessLogic/useSubNav'
import MenuItem from '../MenuItem'
import * as s from './styles'

const NavBar: FC<{
  links: Link[]
  navType: 'topNav' | 'subNav'
}> = ({ links, navType }): JSX.Element => {
  const selectedKey = links.findIndex(({ href }) => window.location.href.includes(href)).toString()
  const admin = adminSubNav.map(x => x.href).includes(window.location.href)
  const subNavStyles = { ...s.subNavWrapper, ...(admin && { ...s.adminPink }) }
  const menuStyles = { ...s[navType], ...(admin && navType === 'subNav' && { ...s.adminPink }) }

  return (
    <section {...navType === 'subNav' && { style: subNavStyles } }>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .iAmNav .ant-dropdown-arrow { 
            top: -4px;
          }
        `
        }}
      />
      <Menu style={menuStyles} mode='horizontal' selectedKeys={[selectedKey]}>
        {links.map(MenuItem)}
      </Menu>
    </section>
  )
}

export default NavBar
